import { useMemo } from 'react';
import { createNoteUpdatesController } from '../helpers/noteUpdates';

export function useNoteUpdates(scopeKey: string | number) {
  return useMemo(() => createNoteUpdatesController(), [scopeKey]);
}
